import React from "react";
import {Route, Routes} from "react-router-dom";
import {Signup} from "./../pages/signup";
import {Login} from "./../pages/login";
import {CardList} from "../components/CardList";
import {HomePrivateDashboard} from "./../pages/dashboard";
import {Layout} from "./../components/Layout/Layout";
import {DiagramBasic} from "../components/DiagramBasic/DiagramBasic";
import {DiagramBasicV2} from "../components/DiagramBasic/DiagramBasicV2";
import {CreditCard} from "../components/CreditCard";
import {Graph} from "../components/Graph";
import {LayoutNavbar} from "../components/Layout/LayoutNavbar";
import {Piechart} from "../components/Piechart";
import {Radarchart} from "../components/Radarchart";
import {Tradingchart} from "../components/Tradingchart";
import {Tradingtrend} from "../components/Tradingtrend";
import {Bubblechart} from "../components/Bubblechart";
import {AnimateLogos} from "../pages/animatelogos";
import {Treemapchart} from "../components/Treemapchart";
import {Counter} from "../components/Counter";
import {GaugeChart} from "../components/GaugeChart";
import {WorldMap} from "../components/WorldMap";
import {HorizontalChart} from "../components/HorizontalChart";
import {VerticalChart} from "../components/VerticalChart";
import {KpiChart} from "../components/KpiChart";
import {AreaChart} from "../components/AreaChart";
import {Heatmap} from "../components/Heatmap";
import {Slider} from "../components/WdSlider";
import CardStack from "../components/WdCardStack";
import Cover from "../components/Cover";
import {Card} from "../components/WdCreditCard";
import {CardCarrousel} from "../components/WdCardCarrousel";
import {SocketConnection} from "../components/WdSocketConnection";
import {SocketConnectionForce} from "../components/WdSocketConnection/SocketConnectionForce";
import {SocketConnectionTest} from "../components/WdSocketConnectionTest";
import {RecordAudio} from "../components/WdRecordAudio";
import {RecordAudioTest} from "../components/WdRecordAudioTest";
import {Background} from "../components/Background";


const AppRouter = () => {
        return (
            <Routes>
                    <Route path="/credit-card" element={<CreditCard />} />
                    <Route path="/piechart" element={<Piechart />} />

                    <Route path="/radarchart" element={<Radarchart />} />
                    <Route path="/treemapChart" element={<Treemapchart />} />
                    <Route path="/heatmapChart" element={<Heatmap />} />
                    <Route path="/worldmap" element={<WorldMap />} />
                    <Route path="/veloster" element={<GaugeChart />} />
                    <Route path="/areachart" element={<AreaChart />} />
                    <Route path="/kpichart" element={<KpiChart />} />
                    <Route path="/horizontalbarchart" element={<HorizontalChart />} />
                    <Route path="/verticalbarchart" element={<VerticalChart />} />

                    <Route path="/counter" element={<Counter />} />
                    <Route path="/recordaudio" element={<RecordAudio />} />
                    <Route path="/recordaudioTest" element={<RecordAudioTest />} />

                    <Route path="/tradingchart" element={<Tradingchart />} />
                    <Route path="/tradingtrend" element={<Tradingtrend />} />
                    <Route path="/cover" element={<Cover/>} />
                    <Route path="/background" element={<Background/>} />
                    <Route path="/bubblechart" element={<Bubblechart />} />


                    {/*           WIDGET            */}

                    <Route path="/slider" element={<Slider/>} />
                    <Route path="/cardStack" element={<CardStack />} />
                    <Route path="/card" element={<Card />} />
                    <Route path="/cardCarrousel" element={<CardCarrousel />} />

                    <Route path="/socket" element={<SocketConnection />} />
                    <Route path="/socketForce/:pusherAppId/:pusherKey/:pusherSecret/:pusherCluster/:pusherChannel/:pusherEvent" element={<SocketConnectionForce />} />
                    <Route path="/socketTest" element={<SocketConnectionTest />} />

                    {/*           OTROS            */}

                    <Route path="/diagrams" element={<Layout><DiagramBasic /> </Layout> }/>
                    <Route path="/diagramsv2" element={<Layout><DiagramBasicV2 /> </Layout> }/>
                    <Route path="/graph" element={<Graph />} />
                    <Route path="/animate-logos" element={ <Layout> <AnimateLogos /> </Layout> } />
                    <Route path="/" element={ <LayoutNavbar> <CardList /> </LayoutNavbar> } />
                    <Route path="/dashboard" element={ <Layout> <HomePrivateDashboard /> </Layout> } />
                    <Route path="/login" element={ <Layout> <Login /> </Layout> } />
                    <Route path="/signup" element={ <Layout> <Signup /> </Layout> } />


            </Routes>
        );
};

export default AppRouter;
